import React from 'react';
import Icon from '../../../components/AppIcon';

const DealershipInfo = ({ dealership }) => {
  return (
    <div className="bg-card rounded-lg shadow-card p-6">
      <div className="flex items-center gap-4 mb-6">
        <div className="w-16 h-16 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon name="Building2" size={32} color="var(--color-primary)" />
        </div>
        <div>
          <h2 className="text-xl font-heading font-semibold text-foreground">
            {dealership?.name}
          </h2>
          <p className="text-sm text-muted-foreground">{dealership?.location}</p>
        </div>
      </div>
      <div className="space-y-4">
        <div className="flex items-start gap-3">
          <Icon name="MapPin" size={18} color="var(--color-muted-foreground)" className="flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-sm text-foreground">{dealership?.street}</p>
            <p className="text-sm text-foreground">
              {dealership?.postalCode} {dealership?.city}
            </p>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <Icon name="Globe" size={18} color="var(--color-muted-foreground)" />
          <a
            href={dealership?.website}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-primary hover:underline"
          >
            {dealership?.website}
          </a>
        </div>

        <div className="flex items-center gap-3">
          <Icon name="Phone" size={18} color="var(--color-muted-foreground)" />
          <a href={`tel:${dealership?.phone}`} className="text-sm text-foreground hover:text-primary transition-smooth">
            {dealership?.phone}
          </a>
        </div>

        <div className="pt-4 border-t border-border">
          <div className="flex items-center justify-between">
            <span className="text-sm text-muted-foreground">Verifizierte Gutscheine</span>
            <span className="text-lg font-heading font-semibold text-primary">
              {dealership?.verifiedVouchers}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DealershipInfo;